<lib-form-field-container
    #anchor
    [isOptional]="isOptional"
     [kind]="FormContainerKind.Date"
    [hideErrors]="popupOpen">
    <ng-content
        label
        select="[label]"></ng-content>

    <ng-container readOnly>
        <div
            class="wrapper-content"
            #providedReadOnly>
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            @if (formControl.value) {
                {{ formControl.value.Render() }}
            } @else {
                <ng-container
                    i18n="@@CommonNotSpecifiedLabel">
                    Not specified
                </ng-container>
            }
        </div>
    </ng-container>

    <ng-container prefixIcon>
        <lib-icon-button
            [kind]="ButtonKind.FormField"
            [size]="ButtonSize.Large"
            [icon]="prefixIcon"
            [disabled]="isDisabled"
            (clicked)="OpenDatePicker()"></lib-icon-button>
    </ng-container>

    @if (isOptional && !isReadOnly) {
        <lib-button
            menu
            [disabled]="isDisabled"
            [kind]="ButtonKind.Link"
            (clicked)="Clear()">
            <ng-container
                label
                i18n="@@FormFieldClearLabel">
                Clear
            </ng-container>
        </lib-button>
    }

    @if (!isLoading && !isReadOnly) {
        <input
            #input
            mbsc-datepicker
            [formControl]="viewControl"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
            [controls]="['date']"
            display="anchored"
            theme="ios"
            [min]="minDateJS"
            [max]="maxDateJS"
            [anchor]="anchor?.containerBox?.nativeElement"
            [attr.placeholder]="placeholderText"
            [touchUi]="isMobile"
            [rtl]="localeInfo.RightToLeft"
            [dayNamesShort]="localeInfo.AbbreviatedDayNames"
            [monthNames]="localeInfo.MonthNames"
            [monthNamesShort]="localeInfo.AbbreviatedMonthNames"
            [dayNamesMin]="localeInfo.AbbreviatedDayNames"
            [firstDay]="firstDayOfWeek"
            (onChange)="ChangeEvent($event)"
            (onOpen)="PopupOpened($event)"
            (onClose)="PopupClosed()"
            (change)="$event.stopPropagation()"
            (onInit)="ComponentInitialized($event)"
            dateFormat="MM/YY"
            dateWheels="MMMM YYYY"
            themeVariant="light"
            [focusOnClose]="false"
            (blur)="OnBlur()"
            (click)="OnClick($event)"
            (focus)="OnFocus()"
            [attr.data-sb-qa]="qaTag" />
    }
</lib-form-field-container>